import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, Router } from '@angular/router';
import { Observable, from, map, of } from 'rxjs';
import { SupabaseService } from '../services/supabase.service';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  private readonly platformId = inject(PLATFORM_ID);

  constructor(
    private supabaseService: SupabaseService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    // Prerendering has no session by definition: always render the anonymous
    // page at build time (auth is re-evaluated in the browser after hydration).
    if (!isPlatformBrowser(this.platformId)) {
      return of(true);
    }
    // Resolve auth via the same Promise-based source of truth as AuthGuard so the
    // two complementary guards never disagree. getCurrentUser() awaits
    // auth.getUser() when the cached subject is empty, so this can't read the
    // un-resolved BehaviorSubject seed on a cold load / hard refresh.
    return from(this.supabaseService.getCurrentUser()).pipe(
      map((user) => {
        if (user) {
          this.router.navigate(['/dashboard']);
          return false;
        }
        return true;
      })
    );
  }
}
